import { render } from "./ItemModal.vue?vue&type=template&id=cec3722e&scoped=true"
import script from "./ItemModal.vue?vue&type=script&lang=js"
export * from "./ItemModal.vue?vue&type=script&lang=js"

import "./ItemModal.vue?vue&type=style&index=0&id=cec3722e&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cec3722e"]])

export default __exports__